import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_games_puzzles: FaireCategoryEntity = {
  token: "catalog_cat_games-puzzles",
  type: "category",
  name: "Games & puzzles",
  count: 2,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
